module.exports = __webpack_public_path__ + "d4016c1054669591c7556198cc14c4ea.png";